import AxiosFetchData from '../pages/AxiosFetchData'
import React, { useState, useEffect, useCallback } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import axios from 'axios';
import { apiUrl } from '../pages/UrlParam';
 import jwt_decode from 'jwt-decode';
export const useJWTDecode =  (id) =>{
   // const {id} = useParams();
    const [token, setToken] = useState({});
    const navigate = useNavigate()

    useEffect(() =>
    {
       // alert(id)
        axios.get(`${apiUrl}/token`).then((response) => {
            setToken(jwt_decode(response.data.accessToken));
        });
          
    },[])
console.log(token)
    return {token};
   
}